import { getToken } from './authHelpers';

export const apiUrl = `${process.env.GATSBY_CMS_URL}/api`;

export const request = async (path, options = {}) => {
  const defaultHeaders = {
    Authorization: `Bearer ${getToken()}`
  };

  const fetchOptions = { next: { tags: [`strapi`] }, ...options };

  // eslint-disable-next-line no-prototype-builtins
  fetchOptions.headers = fetchOptions.hasOwnProperty(`headers`)
    ? { ...defaultHeaders, ...fetchOptions.headers }
    : { ...defaultHeaders };

  const response = await fetch(path, fetchOptions);
  const result = await response.json();

  return result;
};

export const getTypeById = async (type, id, populateQuery = `populate=*`) => {
  const url = new URL(`${apiUrl}/${type}/${id}?${populateQuery}`);

  const { data } = await request(url.href, {
    id
  });

  return Array.isArray(data) ? data[0] : data || null;
};
